import React, { useEffect, useState } from "react";
import { Button, InputLabel, MenuItem, TextField } from "@material-ui/core";

import { TableHead } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Select from "@material-ui/core/Select";

import styles from "./buttonOpenModalCancellationPolicy.module.css";
import selectsData from "../../../../../constants/cancelPoliciesSelectsData.js";
const buttonOpenModalCancellationPolicy = (value, name, fieldUpdateHandler) => {
    const getDefaultDate = (days = 0) => {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return date.toISOString().split("T")[0];
    };

    const defaultRow = () => ({
        fixDate: "",
        countingType: "1",
        term: "0",
        fine: "1",
        percent: "0",
        periods: [{ start: getDefaultDate(0), end: getDefaultDate(1) }],
    });

    const [data, setData] = useState(
        Array.isArray(value)
            ? value
            : value?.length
              ? JSON.parse(value)
              : [defaultRow()],
    );

    useEffect(() => {
        fieldUpdateHandler(name, data);
    }, [data]);

    // Добавить новую строку
    const addRow = () => {
        setData([...data, defaultRow()]);
    };

    // Удалить строку
    const removeRow = (idx) => {
        setData(data.filter((_, i) => i !== idx));
    };

    // Обновить значение в строке
    const updateRow = (idx, key, value) => {
        const newData = [...data];
        newData[idx][key] = value;
        setData(newData);
    };

    const toggleFixDate = (idx, key, value) => {
        const newData = [...data];
        if (value === "2") newData[idx][key] = getDefaultDate(0);
        else newData[idx][key] = "";
        setData(newData);
    };

    const togglePercent = (idx, key, value) => {
        const newData = [...data];

        newData[idx][key] = "0";

        setData(newData);
    };

    // Добавить период в строку
    const addPeriod = (idx) => {
        const newData = [...data];
        newData[idx].periods.push({
            start: getDefaultDate(0),
            end: getDefaultDate(1),
        });
        setData(newData);
    };

    // Удалить период в строке
    const removePeriod = (rowIdx, pIdx) => {
        const newData = [...data];
        newData[rowIdx].periods = newData[rowIdx].periods.filter(
            (_, i) => i !== pIdx,
        );
        setData(newData);
    };

    // Обновить период
    const updatePeriod = (rowIdx, pIdx, key, value) => {
        const newData = [...data];
        newData[rowIdx].periods[pIdx][key] = value;
        setData(newData);
    };

    return (
        <div>
            <div className={styles.cont__cancellationPolicy}>
                <table className={styles.table__cancellationPolicy}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Тип отсчета</TableCell>
                            <TableCell>Срок до времени отсчета</TableCell>
                            <TableCell>Условие</TableCell>
                            <TableCell>Период проживания</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>
                                    <Select
                                        className={
                                            styles.inputs__cancellationPolicy
                                        }
                                        id={styles.countingType}
                                        value={row.countingType}
                                        onChange={(e) => {
                                            updateRow(
                                                idx,
                                                "countingType",
                                                e.target.value,
                                            );
                                            toggleFixDate(
                                                idx,
                                                "fixDate",
                                                e.target.value,
                                            );
                                        }}
                                        label="Выберите тип отсчета"
                                        autoWidth
                                    >
                                        <MenuItem value="1">
                                            {selectsData.countingType["1"]}
                                        </MenuItem>
                                        <MenuItem value="2">
                                            {selectsData.countingType["2"]}
                                        </MenuItem>
                                    </Select>
                                    {row.countingType == 2 ? (
                                        <TextField
                                            className={
                                                styles.inputs__cancellationPolicy +
                                                " " +
                                                styles.marginTop__cancellationPolicy +
                                                " " +
                                                styles.width_date__cancellationPolicy
                                            }
                                            id="fixDate"
                                            type="date"
                                            value={row.fixDate}
                                            onChange={(e) =>
                                                updateRow(
                                                    idx,
                                                    "fixDate",
                                                    e.target.value,
                                                )
                                            }
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        className={
                                            styles.inputs__cancellationPolicy
                                        }
                                        type="number"
                                        value={row.term}
                                        onChange={(e) =>
                                            updateRow(
                                                idx,
                                                "term",
                                                e.target.value,
                                            )
                                        }
                                    />
                                </TableCell>
                                <TableCell>
                                    <Select
                                        className={
                                            styles.inputs__cancellationPolicy
                                        }
                                        id="fine"
                                        value={row.fine}
                                        onChange={(e) => {
                                            updateRow(
                                                idx,
                                                "fine",
                                                e.target.value,
                                            );
                                            togglePercent(
                                                idx,
                                                "percent",
                                                e.target.value,
                                            );
                                        }}
                                        label="Выберите штраф"
                                        autoWidth
                                    >
                                        <MenuItem value="1">
                                            {selectsData.fine["1"]}
                                        </MenuItem>
                                        <MenuItem value="2">
                                            {selectsData.fine["2"]}
                                        </MenuItem>
                                        <MenuItem value="3">
                                            {selectsData.fine["3"]}
                                        </MenuItem>
                                        <MenuItem value="4">
                                            {selectsData.fine["4"]}
                                        </MenuItem>
                                    </Select>
                                    {row.fine == 3 ? (
                                        <TextField
                                            className={
                                                styles.inputs__cancellationPolicy +
                                                " " +
                                                styles.marginTop__cancellationPolicy
                                            }
                                            type="number"
                                            value={row.percent}
                                            onChange={(e) =>
                                                updateRow(
                                                    idx,
                                                    "percent",
                                                    e.target.value,
                                                )
                                            }
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </TableCell>
                                <TableCell>
                                    {row.periods.map((period, pIdx) => (
                                        <div
                                            key={pIdx}
                                            className={
                                                styles.periond_cell__cancellationPolicy
                                            }
                                        >
                                            <TextField
                                                className={
                                                    styles.inputs__cancellationPolicy +
                                                    " " +
                                                    styles.width_date__cancellationPolicy
                                                }
                                                type="date"
                                                value={period.start}
                                                onChange={(e) =>
                                                    updatePeriod(
                                                        idx,
                                                        pIdx,
                                                        "start",
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                            <span>–</span>
                                            <TextField
                                                className={
                                                    styles.inputs__cancellationPolicy +
                                                    " " +
                                                    styles.width_date__cancellationPolicy
                                                }
                                                type="date"
                                                value={period.end}
                                                onChange={(e) =>
                                                    updatePeriod(
                                                        idx,
                                                        pIdx,
                                                        "end",
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                            <div
                                                onClick={() =>
                                                    removePeriod(idx, pIdx)
                                                }
                                                className={
                                                    styles.btns__cancellationPolicy
                                                }
                                            >
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM16.704 12.9H7.104C6.612 12.9 6.204 12.492 6.204 12C6.204 11.508 6.612 11.1 7.104 11.1H16.704C17.196 11.1 17.604 11.508 17.604 12C17.604 12.492 17.208 12.9 16.704 12.9Z"
                                                        fill="#1F1F1F"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    ))}
                                    <div
                                        onClick={() => addPeriod(idx)}
                                        className={
                                            styles.btns__cancellationPolicy
                                        }
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM16.8 12.9H12.9V16.8C12.9 17.292 12.492 17.7 12 17.7C11.508 17.7 11.1 17.292 11.1 16.8V12.9H7.2C6.708 12.9 6.3 12.492 6.3 12C6.3 11.508 6.708 11.1 7.2 11.1H11.1V7.2C11.1 6.708 11.508 6.3 12 6.3C12.492 6.3 12.9 6.708 12.9 7.2V11.1H16.8C17.292 11.1 17.7 11.508 17.7 12C17.7 12.492 17.292 12.9 16.8 12.9Z"
                                                fill="#1F1F1F"
                                            />
                                        </svg>{" "}
                                        Добавить период
                                    </div>
                                </TableCell>
                                <TableCell
                                    className={
                                        styles.text_bottom__cancellationPolicy
                                    }
                                >
                                    <div
                                        onClick={() => removeRow(idx)}
                                        className={
                                            styles.btn_del__cancellationPolicy
                                        }
                                    >
                                        Удалить
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell
                                className={styles.no_border__cancellationPolicy}
                            >
                                <div
                                    onClick={addRow}
                                    className={styles.btns__cancellationPolicy}
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 0C5.388 0 0 5.388 0 12C0 18.612 5.388 24 12 24C18.612 24 24 18.612 24 12C24 5.388 18.612 0 12 0ZM16.8 12.9H12.9V16.8C12.9 17.292 12.492 17.7 12 17.7C11.508 17.7 11.1 17.292 11.1 16.8V12.9H7.2C6.708 12.9 6.3 12.492 6.3 12C6.3 11.508 6.708 11.1 7.2 11.1H11.1V7.2C11.1 6.708 11.508 6.3 12 6.3C12.492 6.3 12.9 6.708 12.9 7.2V11.1H16.8C17.292 11.1 17.7 11.508 17.7 12C17.7 12.492 17.292 12.9 16.8 12.9Z"
                                            fill="#1F1F1F"
                                        />
                                    </svg>
                                    Добавить строку
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </table>
            </div>
        </div>
    );
};

export default buttonOpenModalCancellationPolicy;
